module.exports = __webpack_public_path__ + "d3db2724cb90a6dd78fb9bdce3a3b238.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/QuestionIcon.svg
// module id = 348
// module chunks = 0